import { render, staticRenderFns } from "./BookLeisureTravel.vue?vue&type=template&id=e1b39716"
import script from "./BookLeisureTravel.vue?vue&type=script&lang=js"
export * from "./BookLeisureTravel.vue?vue&type=script&lang=js"
import style0 from "./BookLeisureTravel.vue?vue&type=style&index=0&id=e1b39716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports